export default "<h1>Authenticating</h1>";